<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import FastClick from "../static/js/fastclick.js";
  export default {
    name: "app",
    data: function () {
      return {};
    },
    created() {
      this.$store.dispatch("getAccess");
    },
    mounted() {
      $(function () {
        FastClick.attach(document.body);
      });
    },
  };
</script>

<style lang="scss">
  // html,
  // body,
  // ul,
  // i,
  // li,
  // a,
  // p,
  // nav,
  // header,
  // h1,
  // h2,
  // div,
  // figure {
  //   padding: 0px;
  //   margin: 0px;
  // }
  // ul,
  // li {
  //   list-style: none;
  // }
  // body {
  //   width: 100%;
  //   font-family: "微软雅黑", "Microsoft YaHei", "PingFang SC";
  // }
  // a {
  //   text-decoration: none;
  // }
  // // a:any-link{ color: #ffffff; }
  // // a:-webkit-any-link{ color: #ffffff; }
  // * {
  //   -webkit-overflow-scrolling: touch;
  //   overflow-scrolling: touch;
  // }
  // input,
  // button,
  // textarea {
  //   -webkit-appearance: none;
  // }
  // input,
  // textarea {
  //   -webkit-user-select: auto !important;
  // }
  // button:focus {
  //   outline: none;
  // }
</style>



// WEBPACK FOOTER //
// src/App.vue